module.exports = __webpack_public_path__ + "static/img/picze_bg.2c653b7d.png";